import { LandlineCheckProvider } from 'components/providers/LandlineCheckProvider'

import { ReactNode } from 'react'

import * as Styled from './styled'
import { useTheme } from '@mui/material'

interface AppContainerProps {
  children: ReactNode
}

export default function AppContainer(props: AppContainerProps) {
  const theme = useTheme()

  return (
    <Styled.AppContainer
      id="app-root"
      container
      sx={{
        height: '100vh',
        backgroundColor: 'var(--color-app-container)'
      }}
    >
      <LandlineCheckProvider>{props.children}</LandlineCheckProvider>
    </Styled.AppContainer>
  )
}
